import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import ModalContainer from '@modals/ModalContainer';
import { useFlow } from '@router/stackflow';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { terminateApp } from '@utils/nativeUtils';
import { useTranslation } from 'react-i18next';

const AppTerminationModal: ActivityComponentType = () => {
    const { t } = useTranslation('appTermination');
    const { pop } = useFlow();
    const handleTermination = () => {
        terminateApp();
    };
    return (
        <Modal>
            <ModalContainer>
                <Column fullWidth align='center' spacing={42}>
                    <Text size='lg'>
                        {t('message')}
                    </Text>
                    <Row spacing={10} fullWidth>
                        <Button variant='tertiary' onClick={pop} noPadding fullWidth>
                            {t('cancel')}
                        </Button>
                        <Button onClick={handleTermination} noPadding fullWidth>
                            {t('confirm')}
                        </Button>
                    </Row>
                </Column>
            </ModalContainer>
        </Modal>
    );
};

export default AppTerminationModal;
